import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { rxResource } from '@angular/core/rxjs-interop'
import { map, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { setErrorMessage } from 'src/utils';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class Completion {

  private apiURL: string = environment.apiURL
  private completionEndPoint: string = environment.completionEndPoint
  private queueEndPoint: string = environment.queueEndPoint
  private http = inject(HttpClient)
  protected router = inject( Router );

  private appointmentData = signal<SubmissionPost | null>(null)
  origin = signal<string>('')

  availabilityRessource = rxResource({ 
    request: () => this.appointmentData(),
    loader: ( {request} ) => {
      if(this.appointmentData() === null) return of (null)
      return this.http.post<AppointmentResponse>(`${this.apiURL}${(this.origin() === 'queue') ? this.queueEndPoint : this.completionEndPoint}`, request).pipe(
        map(availabilityResponse => availabilityResponse )
      )
    }
  })

  submitAppointment(data: SubmissionPost){
    this.appointmentData.set(data)
  }

  completionResponse = computed(() => this.availabilityRessource.value() );
  error = computed(() => this.availabilityRessource.error() as HttpErrorResponse);
  errorMessage = computed(() => setErrorMessage(this.error(), 'Completion'));
  isLoading = this.availabilityRessource.isLoading();

  eff = effect( () => {
    if(!this.availabilityRessource.isLoading() && this.appointmentData() != null){
      if(this.error() === undefined)
        this.router.navigate([`/your-appointment`, this.completionResponse()?.accessID ?? this.completionResponse()?.eventID],  {queryParamsHandling: 'merge'})
      else if(this.error().status === 409){}
    }
  })


}
